import { render, staticRenderFns } from "./SimpleCard.vue?vue&type=template&id=0a42ed42&scoped=true&"
import script from "./SimpleCard.vue?vue&type=script&lang=js&"
export * from "./SimpleCard.vue?vue&type=script&lang=js&"
import style0 from "./SimpleCard.vue?vue&type=style&index=0&id=0a42ed42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a42ed42",
  null
  
)

export default component.exports